import { Layer, Shape, Point, Line, Polygon, GlobalContext } from '../../../../context/context';
import L from 'leaflet';

interface MapEventHandlerProps {
    mapRef: React.MutableRefObject<L.Map | null>;
    global: GlobalContext;
    setOsmImportProgress: (progress: number | null) => void;
}

export function useMapEventHandlers({ mapRef, global, setOsmImportProgress }: MapEventHandlerProps) {
    const handleZoomToLayer = (event: CustomEvent<{ shapes: Shape[] }>) => {
        if (!mapRef.current) return;
        const shapes = event.detail.shapes;
        
        // Collect all coordinates from visible shapes
        let latlngs: [number, number][] = [];
        shapes.forEach((shape: Shape) => {
            if (shape.hidden) return;
            
            switch (shape.type) {
                case 'point':
                    latlngs.push(shape.coordinates);
                    break;
                case 'line':
                    latlngs.push(...shape.coordinates);
                    break;
                case 'polygon':
                    if (shape.coordinates && shape.coordinates[0]) {
                        latlngs.push(...shape.coordinates[0]);
                    }
                    break;
            }
        });

        if (latlngs.length > 0) {
            const bounds = L.latLngBounds(latlngs.map(([lat, lng]) => [lat, lng]));
            mapRef.current.fitBounds(bounds.pad(0.2));
        }
    };

    const handleZoomToShape = (event: CustomEvent<{ shape: Shape }>) => {
        if (!mapRef.current) return;
        const shape = event.detail.shape;
        if (!shape) return;

        switch (shape.type) {
            case 'point':
                mapRef.current.setView([shape.coordinates[0], shape.coordinates[1]], 18, { animate: true });
                break;
            case 'line':
                if (shape.coordinates.length === 1) {
                    mapRef.current.setView([shape.coordinates[0][0], shape.coordinates[0][1]], 18, { animate: true });
                } else {
                    const bounds = L.latLngBounds(shape.coordinates.map(([lat, lng]: [number, number]) => [lat, lng]));
                    mapRef.current.fitBounds(bounds.pad(0.2));
                }
                break;
            case 'polygon':
                if (shape.coordinates && shape.coordinates[0]) {
                    if (shape.coordinates[0].length === 1) {
                        mapRef.current.setView([shape.coordinates[0][0][0], shape.coordinates[0][0][1]], 18, { animate: true });
                    } else {
                        const bounds = L.latLngBounds(shape.coordinates[0].map(([lat, lng]: [number, number]) => [lat, lng]));
                        mapRef.current.fitBounds(bounds.pad(0.2));
                    }
                }
                break;
        }
    };

    return {
        handleZoomToLayer,
        handleZoomToShape
    };
} 